import { z } from 'zod';

/**
 * Factures des partenaires sous-traitants. Une fois l'intervention validée
 * (« confirmée pour paiement »), le partenaire téléverse sa facture en
 * indiquant le montant ; BCL (Amine) procède au paiement et la marque payée.
 */

export const partnerInvoiceStatusSchema = z.enum(['a_payer', 'paye']);
export type PartnerInvoiceStatus = z.infer<typeof partnerInvoiceStatusSchema>;

export const requestPartnerInvoiceUploadSchema = z.object({
  interventionId: z.string().uuid(),
  filename: z.string().trim().min(1).max(255),
  contentType: z.string().trim().min(1).max(120),
  sizeBytes: z.number().int().positive().max(50 * 1024 * 1024),
  // Montant TTC en euros (2 décimales). Converti en centimes côté serveur.
  amount: z.number().positive().max(10_000_000),
});
export type RequestPartnerInvoiceUploadInput = z.infer<
  typeof requestPartnerInvoiceUploadSchema
>;

export const payPartnerInvoiceSchema = z.object({
  paymentReference: z.string().trim().max(120).optional(),
});
export type PayPartnerInvoiceInput = z.infer<typeof payPartnerInvoiceSchema>;

export const partnerInvoiceSchema = z.object({
  id: z.string().uuid(),
  interventionId: z.string().uuid(),
  partnerId: z.string().uuid(),
  filename: z.string(),
  contentType: z.string(),
  sizeBytes: z.number(),
  s3Key: z.string(),
  amountCents: z.number().int(),
  status: partnerInvoiceStatusSchema,
  paymentReference: z.string().nullable(),
  uploadedAt: z.string().datetime(),
  paidAt: z.string().datetime().nullable(),
});
export type PartnerInvoice = z.infer<typeof partnerInvoiceSchema>;
